import request from "@utils/request";

/**
 * 触发任务
 * @param id
 * @returns {*}
 */
export function  trigger(id){
    return request.get("/quartz/entity/trigger?id="+id);
}

/**
 * 暂停任务
 * @param id
 * @returns {*}
 */
export function  pause(id){
    return request.get("/quartz/entity/pause?id="+id);
}

/**
 * 恢复任务
 * @param id
 * @returns {*}
 */
export function resume(id){
    return request.get("/quartz/entity/resume?id="+id);
}

/**
 * 移除任务
 * @param id
 * @returns {*}
 */
export function remove(id){
    return request.get("/quartz/entity/remove?id="+id);
}
